import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IBoMon } from "../../../model/respone/category/IBoMon";
import { IBoMonFilterReducer } from "../../reducer-model/category/IBoMonReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eBoMonActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IBoMon[],
  LOAD_ERRR: "",

  CHANGE_FILTER:{} as IBoMonFilterReducer,

  SHOW_EDIT_MODAL: {} as IBoMon | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IBoMon,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: {} as IIdsRequest,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

  CHANGE_SELECTED_IDS: {} as number[]

};
export const eBoMonActionIds = generateActionTypeIds(
  eBoMonActionsObj,
  "BO_MON"
);
export type IBoMonActionTypes = IGenericActionType<
  typeof eBoMonActionsObj,
  "BO_MON"
>;
